<template>
  <div>
    <div style="font-size: 18px; color: #171a1e">地址配置查询</div>
    <div style="margin-top: 20px">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="输入搜索:" style="height: 36px">
          <el-input
            v-model="form.search"
            placeholder="简称/全称/地址"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="类型:" style="margin: 0 36px">
          <el-select v-model="form.type" placeholder="请选择活动区域">
            <el-option label="全部" value="3"></el-option>
            <el-option label="系统" value="1"></el-option>
            <el-option label="个人维护" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序:">
          <el-select v-model="form.sort" placeholder="请选择活动区域">
            <el-option label="默认排序" value="1"></el-option>
            <el-option label="热门排序" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="left_margin">
          <el-button type="primary" @click="onSubmit" class="inquire"
            >搜索</el-button
          >
          <el-button type="primary" class="reset" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="big_box">
      <!-- 侧边搜索 -->
      <div class="left_list">
        <div>
          <el-input
            size="small"
            placeholder="搜索位置"
            prefix-icon="el-icon-search"
            clearable
            @input="inputVal"
            v-model="searchVal"
          >
          </el-input>
        </div>
        <div style="margin-top: 15px">
          <el-tree
            :data="dataTree"
            :props="defaultProps"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </div>
      <div class="right_table">
        <div style="display: flex">
          <div class="newly_built">
            <el-button
              type="primary"
              icon="el-icon-plus"
              class="reset"
              v-if="premission('New:landmark')"
              @click="handleAdd"
              >新建</el-button
            >
          </div>
          <div>
            <el-button
              type="primary"
              icon="el-icon-refresh-right"
              v-if="premission('Update:Data')"
              @click="handleEdit"
              >更新</el-button
            >
          </div>
        </div>

        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          style="margin-top: 15px"
        >
          <el-tab-pane :label="labelVal" name="298"> </el-tab-pane>
          <el-tab-pane label="周边学校" name="300"></el-tab-pane>
          <el-tab-pane label="周边景区" name="299"></el-tab-pane>
          <el-tab-pane label="附近交通" name="297"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="热门" prop="hotspot">
            <template slot-scope="scope">
              <div
                v-if="scope.row.hotspot == 1"
                style="text-align: center"
                @click="hotspot_Btn(scope.row)"
              >
                <img
                  src="../../image/Vector.png"
                  alt=""
                  style="width: 20px; height: 24px"
                />
              </div>
              <div
                v-else
                style="text-align: center"
                @click="hotspot_Btn(scope.row)"
              >
                <img
                  src="../../image/Vector2.png"
                  alt=""
                  style="width: 20px; height: 24px"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column type="index" label="排名" prop="name">
          </el-table-column>
          <el-table-column label="搜索量" prop="searchNum">
            <template slot-scope="scope">
              <div style="text-align: center">
                {{ scope.row.searchNum }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="简称"
            prop="abbreviation"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="ID"
            prop="mapLandmarkId"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="全称" prop="fllName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="地址" prop="address" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="经纬度" prop="name" show-overflow-tooltip>
            <template slot-scope="scope">
              <div>{{ scope.row.latitude }},{{ scope.row.longitude }}</div>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remarks" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="更新时间"
            prop="creationTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="更新人" prop="userName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="是否显示">
            <template slot-scope="scope">
              <!-- v-model="scope.row.display" -->
              <el-switch
                :value="scope.row.display + ''"
                active-color="#F6B439"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
                @change="switch_btn(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope">
              <el-button
                @click="handleClickEdit(scope.row)"
                type="text"
                size="small"
                icon="el-icon-edit-outline"
                style="font-size: 14px"
                v-if="premission('Edit:landmark')"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="handleClickRemove(scope.row)"
                style="font-size: 14px"
                v-if="premission('Delete:landmark')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="+MapLandmark.pageNum"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="+MapLandmark.pageSize"
            layout="total,sizes, prev, pager, next, jumper"
            :total="+total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 新建地址弹出框 -->
    <el-dialog title="新建地标" width="750px" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="address" label-width="80px">
        <el-form-item label="类型:">
          <el-select
            v-model="address.type"
            placeholder="请选择类型"
            style="width: 100%"
          >
            <!-- <el-option label="系统" value="1"></el-option>
            <el-option label="个人维护" value="2"></el-option> -->

            <el-option
              v-for="item in options"
              :key="item.iConfigId"
              :label="item.vMenuName"
              :value="item.iConfigId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="全称:">
          <el-input v-model="address.name"></el-input>
        </el-form-item>
        <el-form-item label="简称:">
          <el-input v-model="address.nameFor"></el-input>
        </el-form-item>
        <el-form-item
          label="省/市/区:"
          label-width="80px"
          style="color: #000000"
        >
          <el-cascader
            style="width: 100%"
            clearable
            :props="cityProps"
            v-model="address.cityValue"
            :options="cityOptions"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址:" label-width="80px">
          <el-autocomplete
            v-model="address.detailed"
            :fetch-suggestions="querySearch"
            placeholder="请输入详细地址"
            style="width: 100%"
            :trigger-on-focus="false"
            @select="handleSelect"
          />

          <!-- <el-input v-model="address.detailed" @blur="detailed"></el-input> -->
        </el-form-item>
        <el-form-item label="门牌号:" label-width="80px">
          <el-input v-model="address.number"></el-input>
        </el-form-item>
        <el-form-item label="地图上的位置:" label-width="80px">
          <baidu-map
            class="map"
            :center="this.frameCenter"
            :zoom="this.zoom"
            @ready="handlerBMap"
          >
            <!-- 放大缩小 -->
            <bm-navigation
              type="BMAP_NAVIGATION_CONTROL_SMALL"
              anchor="BMAP_ANCHOR_TOP_RIGHT"
            ></bm-navigation>
            <!-- 标记点 -->
            <bm-marker
              :position="{ lng: markers.lng, lat: markers.lat }"
              :dragging="true"
              @dragend="getMapCenter"
            >
            </bm-marker>
          </baidu-map>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input type="textarea" v-model="address.desc"></el-input>
        </el-form-item>
        <el-form-item label="显示状态:" label-width="100px">
          <el-radio v-model="address.resource" label="1">显示</el-radio>
          <el-radio v-model="address.resource" label="0">不显示</el-radio>
        </el-form-item>
        <el-form-item
          label="是否设为热门:"
          label-width="100px"
          class="radioMar"
        >
          <el-radio v-model="address.hot" label="1" class="radioVal"
            >是</el-radio
          >
          <el-radio v-model="address.hot" label="0">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" class="reset" @click="addHouseTrue"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 新建地址弹出框 -->
    <!-- 编辑表单弹出框 -->
    <el-dialog title="编辑" width="750px" :visible.sync="dialogFormVisibleEdit">
      <el-form ref="form" :model="addressEdit" label-width="80px">
        <el-form-item label="类型:">
          <el-select
            v-model="addressEdit.type"
            disabled
            placeholder="请选择活动区域"
            style="width: 100%"
          >
            <el-option label="飞机场" value="304"></el-option>
            <el-option label="火车站" value="303"></el-option>
            <el-option label="长途汽车站" value="302"></el-option>
            <el-option label="地铁站" value="301"></el-option>
            <el-option label="高校" value="300"></el-option>
            <el-option label="景区" value="299"></el-option>
            <el-option label="商圈" value="298"></el-option>
            <el-option label="交通设施" value="297"></el-option>
            <el-option label="地标管理" value="296"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简称:">
          <el-input v-model="addressEdit.nameFor"></el-input>
        </el-form-item>
        <el-form-item label="全称:">
          <el-input
            v-model="addressEdit.name"
            :disabled="disabledForm"
          ></el-input>
        </el-form-item>
        <el-form-item label="ID:">
          <el-input
            v-model="addressEdit.id"
            :disabled="disabledForm"
          ></el-input>
        </el-form-item>
        <el-form-item label="详细地址:" label-width="80px">
          <el-input
            v-model="addressEdit.detailed"
            :disabled="disabledForm"
          ></el-input>
        </el-form-item>
        <el-form-item label="经纬度:">
          <el-input
            v-model="addressEdit.longitude"
            :disabled="disabledForm"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input type="textarea" v-model="addressEdit.desc"></el-input>
        </el-form-item>
        <el-form-item label="显示状态:" label-width="100px">
          <el-radio v-model="addressEdit.resource" label="1">显示</el-radio>
          <el-radio v-model="addressEdit.resource" label="0">不显示</el-radio>
        </el-form-item>
        <el-form-item label="是否设为热门:" label-width="100px">
          <el-radio v-model="addressEdit.hot" label="1" class="radioVal"
            >是</el-radio
          >
          <el-radio v-model="addressEdit.hot" label="0">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleEdit = false">取 消</el-button>
        <el-button type="primary" class="reset" @click="FormVisibleEditTrue"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑表单弹出框 -->
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import axios from "axios";
import premission from "../../utils/permission";
import {
  map_Landmark,
  get_Config,
  get_MapLandmark,
  add_MapLandmark,
  update_MapLandmark,
  delete_MapLandmark,
  update_MapLandmarkApi
} from "../../api/index";
export default {
  components: {
    BaiduMap
  },
  mixins: [premission],
  data() {
    return {
      options: [],

      labelVal: "周边商圈",
      // textColor:"#f6b439",
      value: true,
      valueDis: false,
      disabledForm: false,
      addressEdit: {
        type: "304",
        name: "",
        nameFor: "",
        id: "",
        detailed: "",
        longitude: "",
        desc: "",
        resource: "1",
        hot: "1"
      },
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      // 地图缩放
      zoom: 1,
      // 点的经纬度
      markers: {
        lng: undefined,
        lat: undefined
      },
      // 画框中间的经纬度
      frameCenter: "中国",
      // 级联选择器选择的数据检索
      cityValue: "中国",
      // 级联选择器数据
      cityOptions: [],
      // 新建地址时候的表单数据
      address: {
        type: "",
        name: "",
        nameFor: "",
        desc: "",
        resource: "1",
        hot: "1",

        cityValue: "",
        detailed: "",
        number: "",
        lng: "",
        lat: ""
      },
      cityProps: {
        value: "name",
        label: "name",
        children: "districts"
        // expandTrigger: "hover",
      },
      dataTree: [],
      defaultProps: {
        children: "data",
        label: "name"
      },
      searchVal: "",
      tableData: [],
      activeName: "298",
      form: {
        search: "",
        type: "3",
        sort: "1"
      },
      mapLocation: {
        address: undefined,
        coordinate: undefined
      },
      custemListData: {
        pageNum: "1",
        pageSize: "10"
      },
      total: 10,

      MapLandmark: {
        pageNum: "1",
        pageSize: "5",
        // fllName: "", //搜索字段
        city: "", //市
        district: "", //区

        type: "3", //类型
        cusDefine1: "", //排序
        typeId: "298"
      },
      cityVal: {
        name: ""
      },
      updateMap: {
        //  query: "",
        region: ""
      }
    };
  },
  methods: {
    //修改热门状态
    hotspot_Btn(row) {
      let text = row.hotspot == "1" ? "取消" : "添加";
      this.$confirm("确认要" + text + "热门吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let num;
          if (row.hotspot == 1) {
            num = 0;
          } else {
            num = 1;
          }

          const { data: res } = await update_MapLandmark({
            mapLandmarkId: row.mapLandmarkId,
            hotspot: num
          });
          console.log(res, "remmeng");

          this.$message({
            type: "success",
            message: res.msg
          });
          this.getMapLandmark();
        })
        .catch(() => {});
    },

    handlerBMap({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
      if (this.mapLocation.coordinate && this.mapLocation.coordinate.lng) {
        this.markers.lng = this.mapLocation.coordinate.lng;
        this.markers.lat = this.mapLocation.coordinate.lat;
        map.addOverlay(new this.BMap.Marker(this.mapLocation.coordinate));
      }
    },

    querySearch(queryString, cb) {
      console.log(queryString, cb, 55556);
      var that = this;
      var myGeo = new this.BMap.Geocoder();
      myGeo.getPoint(
        queryString,
        function(point) {
          if (point) {
            that.mapLocation.coordinate = point;
            // that.makerCenter(point);
          } else {
            that.mapLocation.coordinate = null;
          }
        },
        this.locationCity
      );
      var options = {
        onSearchComplete: function(results) {
          console.log(results, 333);
          if (local.getStatus() === 0) {
            // 判断状态是否正确
            var s = [];
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              var x = results.getPoi(i);
              var item = { value: x.address + x.title, point: x.point };
              s.push(item);
              cb(s);
            }
          } else {
            cb();
          }
        }
      };
      var local = new this.BMap.LocalSearch(this.map, options);
      local.search(queryString);
    },

    handleSelect(e) {
      this.markers.lat = e.point.lat;
      this.markers.lng = e.point.lng;
      var cityValue = this.cityValue + this.address.detailed;
      this.gainAddress(cityValue);
      this.zoom = 20;
    },

    // 修改开关状态
    switch_btn(row) {
      let text = row.display == "1" ? "隐藏" : "显示";
      this.$confirm("确认要" + text + "该条数据吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let num;
          if (row.display == 1) {
            num = 0;
          } else {
            num = 1;
          }

          const { data: res } = await update_MapLandmark({
            mapLandmarkId: row.mapLandmarkId,
            display: num
          });
          console.log(res, "kaiguan");

          this.$message({
            type: "success",
            message: res.msg
          });
          this.getMapLandmark();
        })
        .catch(() => {});
    },

    //搜索位置事件
    async inputVal(value) {
      console.log(value, 566666);
      this.cityVal.name = value;
      this.Landmark_city();
      //  this.dataTree = res.data;
    },
    //房源城市
    async Landmark_city() {
      const { data: res } = await map_Landmark(this.cityVal);
      console.log(res, "房源城市");
      if (res.code == 200) {
        this.dataTree = res.data;
      }
    },
    //房源配置信息
    async getHouseConfig() {
      const { data: res } = await get_Config();
      console.log(res, "配置信息");
      if (res.code == 200) {
        this.options = res.data;
      }
    },
    //房源地段信息
    async getMapLandmark() {
      const { data: res } = await get_MapLandmark(this.MapLandmark);
      console.log(res, "房源地段信息");
      if (res.code == 200) {
        this.tableData = res.rows;
        this.total = res.total;
      }
    },
    //编辑
    handleClickEdit(row) {
      if (row.type == 1) {
        this.disabledForm = true;
      }
      console.log(row);
      this.addressEdit.type = row.typeId.toString();
      this.addressEdit.addressEdit = row.type.toString(); //类型
      this.addressEdit.nameFor = row.abbreviation; //简称
      this.addressEdit.name = row.fllName; //全称
      this.addressEdit.id = row.mapLandmarkId; //ID
      this.addressEdit.detailed = row.address; //详细地址
      this.addressEdit.longitude = row.longitude + "," + row.latitude; //经纬度
      this.addressEdit.desc = row.remarks; //备注
      this.addressEdit.resource = row.display.toString(); //显示状态
      this.addressEdit.hot = row.hotspot.toString(); //是否热门
      this.dialogFormVisibleEdit = true;
    },
    //编辑确定
    async FormVisibleEditTrue() {
      const { data: res } = await update_MapLandmark({
        type: this.addressEdit.type, //类型
        fllName: this.addressEdit.name, //全称
        abbreviation: this.addressEdit.nameFor, //简称
        address: this.addressEdit.detailed, //详细地址
        mapLandmarkId: this.addressEdit.id, //地址ID
        longitude: this.markers.lng, //经度
        latitude: this.markers.lat, //维度
        remarks: this.addressEdit.desc, //备注
        display: this.addressEdit.resource, //显示状态
        hotspot: this.addressEdit.hot //热门
      });
      if (res.code == 200) {
        console.log(res, 565656);
        this.$message({
          type: "success",
          message: res.msg
        });
      } else {
        this.$message({
          type: "error",
          message: res.msg
        });
      }
      this.dialogFormVisibleEdit = false;
      this.getMapLandmark();
    },

    //删除
    handleClickRemove(row) {
      console.log(row);
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { data: res } = await delete_MapLandmark({
            mapLandmarkId: row.mapLandmarkId
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
          console.log(res, "删除");
          this.getMapLandmark();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 拖拽地图点位之后的经纬度
    getMapCenter(event) {
      console.log(event);
    },
    // 详细地址input失去焦点事件
    detailed() {
      var cityValue = this.cityValue + this.address.detailed;
      this.gainAddress(cityValue);
      this.zoom = 20;
    },
    // 获取地图经纬度
    gainAddress(cityValue) {
      console.log(cityValue);
      this.$jsonp("https://api.map.baidu.com/geocoding/v3/", {
        address: cityValue,
        output: "json",
        ak: "gYOBOyROwCVTPTZavwZ6GumDClyRSjhB"
      })
        .then(res => {
          console.log(res, 9999);

          // var lng = res.result.location.lng;
          // var lat = res.result.location.lat;

          this.markers.lng = res.result.location.lng;
          this.markers.lat = res.result.location.lat;
          this.frameCenter = res.result.location;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 级联选择器click
    handleChange(value) {
      this.cityValue = value.join("");
      var cityValue = this.cityValue;
      this.gainAddress(cityValue);
      this.zoom = 15;
    },
    async getMapList() {
      var url = `https://restapi.amap.com/v3/config/district?keywords=${this.cityValue}&subdistrict=3&extensions=base&key=33b16f7c43c82d8c72312ec37969aaa2`;
      // var url = `https://api.map.baidu.com/api_region_search/v1/?keyword=${address}&sub_admin=3&ak=gYOBOyROwCVTPTZavwZ6GumDClyRSjhB&callback=showLocation`;
      axios.get(url).then(res => {
        this.cityOptions = this.getTreeData(res.data.districts[0].districts);
      });
    },
    /* 递归处理末尾项district为0的空项 */
    getTreeData(data) {
      // 循环遍历返回的数据
      for (var i = 0; i < data.length; i++) {
        if (data[i].districts.length < 1) {
          // districts若为空数组，则将districts设为undefined
          data[i].districts = undefined;
        } else {
          // districts若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].districts);
        }
      }
      return data;
    },
    handleNodeClick(data) {
      this.MapLandmark.city = "";
      this.MapLandmark.district = "";

      this.updateMap.region = data.name;
      console.log(data);
      // this.updateMap.query = data.name;
      if (data.lv == "2") {
        this.MapLandmark.city = data.name;
        this.getMapLandmark();
      }
      if (data.lv == "3") {
        this.MapLandmark.district = data.name;
        this.getMapLandmark();
      }
      //this.MapLandmark.fllName = data.name;
    },
    //已成交
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      window.localStorage.setItem("custem", val);
      this.MapLandmark.pageSize = val;
      this.getMapLandmark();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.MapLandmark.pageNum = val;
      this.getMapLandmark();
    },
    //搜索
    onSubmit() {
      this.MapLandmark.fllName = this.form.search;
      this.MapLandmark.type = this.form.type;
      this.MapLandmark.cusDefine1 = this.form.sort;
      this.getMapLandmark();
    },
    reset() {
      this.form.search = "";
      this.form.type = "1";
      this.form.sort = "1";
      this.MapLandmark.fllName = "";
      this.MapLandmark.type = "";
      this.MapLandmark.cusDefine1 = "";
      this.getMapLandmark();
    },

    //新建
    handleAdd() {
      console.log(666);
      this.dialogFormVisible = true;
    },
    //新建确定
    async addHouseTrue() {
      const { data: res } = await add_MapLandmark({
        typeId: this.address.type, //类型
        fllName: this.address.name, //全称
        abbreviation: this.address.nameFor, //简称
        province: this.address.cityValue[0], //省
        city: this.address.cityValue[1], //市
        district: this.address.cityValue[2], //区
        address: this.address.detailed, //详细地址
        location: this.address.number, //门牌号
        longitude: this.markers.lng, //经度
        latitude: this.markers.lat, //维度
        remarks: this.address.desc, //备注
        display: this.address.resource, //显示状态
        hotspot: this.address.hot //热门
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.msg
        });
        this.getMapLandmark();
      } else {
        this.$message({
          type: "error",
          message: res.msg
        });
      }
      (this.address = {
        type: "",
        name: "",
        nameFor: "",
        desc: "",
        resource: "1",
        hot: "1",
        cityValue: "",
        detailed: "",
        number: "",
        lng: "",
        lat: ""
      }),
        (this.dialogFormVisible = false);
      console.log(res, 565656);
    },
    //更新
    async handleEdit() {
      // if (this.updateMap.query) {
      //   this.updateMap.region = this.labelVal;
      // }
      const { data: res } = await update_MapLandmarkApi(this.updateMap);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.msg
        });
        this.updateMap = {
          //  query: "",
          region: ""
        };
        this.getMapLandmark();
      } else {
        this.$message({
          type: "error",
          message: res.msg
        });
      }
      console.log(res, 89898);
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.MapLandmark.typeId = tab.name;
      this.getMapLandmark();
    }
  },
  created() {
    this.getMapList();
    //房源城市
    this.Landmark_city();
    //房源配置信息
    this.getHouseConfig();
    //房源地址信息
    this.getMapLandmark();
  }
};
</script>
<style lang="less" scoped>
/deep/.el-input--suffix .el-input__inner {
  height: 36px;
}
.inquire {
  margin: 0 10px 0 20px;
}
.reset {
  background: #f6b439;
  color: #fff;
  border: none;
}
.el-button--primary {
  border: none;
}
/deep/.el-table th {
  font-family: Microsoft YaHei;
  font-style: normal;
  font-weight: normal;
  text-align: center;
  background-color: #f2f2f2;
}

.map {
  width: 100%;
  height: 300px;
}

.newly_built {
  margin-right: 36px;
}
.big_box {
  overflow: hidden;
  .left_list {
    margin-top: 20px;
    padding: 0 20px 20px 0;
    float: left;
    width: 180px;
  }
  .right_table {
    float: left;
    width: 80%;

    padding-left: 30px;
    border-left: 1px solid #ccc;
  }

  /deep/.el-tabs__item.is-active {
    color: #f6b439;
  }
  /deep/.el-tabs__active-bar {
    background-color: #f6b439;
  }
  /deep/.el-input--suffix .el-input__inner {
    background: #f2f2f2;
    border-radius: 15px;
    height: 30px;
  }
  .tabsVal {
    background-color: #f2f2f2;
  }
}
</style>
